import { fetchWithAuth } from "@/lib/MemoBE/fetchWithAuth";
import {
  BookingDto,
  DeclineBookingRequest,
  BookingParticipantsRequest,
  BookingSearchRequest,
  BookingSearchResponse,
  UpsertBookingRequest,
} from "@/interFace/bookings/types";

const BOOKINGS_BASE = "/api/bookings";

const normalizeBookingSearchResponse = (
  response: BookingSearchResponse | BookingDto[] | null
): BookingSearchResponse => {
  if (Array.isArray(response)) {
    return { items: response };
  }

  return {
    items: response?.items || [],
  };
};

export const searchBookings = async (
  request: BookingSearchRequest
): Promise<BookingSearchResponse> => {
  const response = await fetchWithAuth(`${BOOKINGS_BASE}/search`, "POST", request);
  return normalizeBookingSearchResponse(response);
};

export const getBookingById = async (id: string): Promise<BookingDto> => {
  return fetchWithAuth(`${BOOKINGS_BASE}/${id}`, "GET");
};

export const createBooking = async (
  request: UpsertBookingRequest
): Promise<BookingDto> => {
  return fetchWithAuth(BOOKINGS_BASE, "POST", request);
};

export const updateBooking = async (
  id: string,
  request: UpsertBookingRequest
): Promise<BookingDto> => {
  return fetchWithAuth(`${BOOKINGS_BASE}/${id}`, "PUT", request);
};

export const cancelBooking = async (id: string): Promise<void> => {
  await fetchWithAuth(`${BOOKINGS_BASE}/${id}`, "DELETE");
};

export const declineBooking = async (
  id: string,
  request: DeclineBookingRequest
): Promise<void> => {
  await fetchWithAuth(`${BOOKINGS_BASE}/${id}/decline`, "POST", request);
};

export const approveBooking = async (id: string): Promise<void> => {
  await fetchWithAuth(`${BOOKINGS_BASE}/${id}/approve`, "POST");
};

export const addBookingParticipants = async (
  id: string,
  request: BookingParticipantsRequest
): Promise<BookingDto> => {
  return fetchWithAuth(`${BOOKINGS_BASE}/${id}/participants`, "POST", request);
};

export const removeBookingParticipant = async (
  id: string,
  userId: string
): Promise<BookingDto> => {
  return fetchWithAuth(`${BOOKINGS_BASE}/${id}/participants/${userId}`, "DELETE");
};
